// src/components/skeletons/ProductGridSkeleton.jsx

import React from "react";

const ProductCardSkeleton = () => (
  <div className="border rounded-lg p-4 shadow w-full max-w-[250px] animate-pulse">
    <div className="w-full h-[280px] bg-gray-200 rounded-md mb-4"></div>
    <div className="h-5 bg-gray-300 rounded w-3/4 mb-2"></div>
    <div className="h-4 bg-gray-300 rounded w-1/2 mb-4"></div>
    <div className="flex gap-2">
      {[...Array(3)].map((_, idx) => (
        <div key={idx} className="w-5 h-5 rounded-full bg-gray-300"></div>
      ))}
    </div>
  </div>
);

const ProductGridSkeleton = () => {
  console.log("hello2222");
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 justify-items-center p-6 max-w-7xl mx-auto">
      {[...Array(8)].map((_, idx) => (
        <ProductCardSkeleton key={idx} />
      ))}
    </div>
  );
};

export default ProductGridSkeleton;
